import React from 'react';
import ReactDOM from 'react-dom';
import App, {route} from 'library/App';
// import ServiceWorker from 'library/ServiceWorker';

route('/app/@public/views/Movies', 'movies@getAll');
route('/app/movies/:movies_id/shows/list.html@public/views/Shows', ['movies@getAll', 'shows@getByMovie']);
route('/app/movies/:movies_id/shows/:shows_id/products/list.html@public/views/Products', ['movies@getAll', 'shows@getByMovie', 'products@getByShow']);
route('/app/movies/:movies_id/shows/:shows_id/orders/:orders_id/payment.html@public/views/Payment');
route('/app/movies/:movies_id/shows/:shows_id/orders/:orders_id/summary.html@public/views/Summary', ['movies@getAll', 'shows@getByMovie']);

ReactDOM.render(<App />, document.getElementById('root'));

/*

if(process.env.NODE_ENV === 'production'){

    console.log('Register Service Worker');

    ServiceWorker.register();
}

*/
